import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { useFormik } from 'formik';
import { Tooltip } from 'antd';
import { Code } from '@mui/icons-material';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';
import { adminMainUrl } from '../../../../Config';
import { DesignationApi } from '../../../../Redux/action/MasterAction';
import AddMaster from './AddMaster';

const RelationList = ({ accessedModules, accessedPermission }) => {
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    // const { name } = useParams();
    const dispatch = useDispatch();
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,

    } = useSelector(state => state?.MasterReducer);
    useEffect(() => {
        dispatch(DesignationApi(adminMainUrl));
    }, [adminMainUrl, reload]);
    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    let formik = useFormik({

        onSubmit: (values) => {
            console.log(values)
        },
    });
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Importer", dataIndex: "Importer", key: "Importer" },
        { title: "Consignor", dataIndex: "Consignor", key: "Consignor" },
        { title: "Relation", dataIndex: "Relation", key: "Relation" },
        { title: "Base", dataIndex: "Base", key: "Base" },

        { title: "Condition", dataIndex: "Condition", key: "Condition" },
        { title: "Method", dataIndex: "Method", key: "Method" },
        { title: "Custom House", dataIndex: "CustomHouse", key: "CustomHouse" },
        { title: "SVB", dataIndex: "SVB", key: "SVB" },

        { title: "svbRef", dataIndex: "svbRef", key: "svbRef" },
        { title: "RefDate", dataIndex: "RefDate", key: "RefDate" },

        { title: "Status", dataIndex: "Status", key: "Status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Importer: "", // Ensure date formatting as neede
        Consignor: "",
        Relation: "",
        Base: "",

        Condition: "", // Ensure date formatting as neede
        Method: "",
        CustomHouse: "",
        SVB: "",
        svbRef: "", // Ensure date formatting as neede
        RefDate: "",

        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>


            </>
        ,
        action: (
            <>
            </>
            // <div className="dropdown table-action">
            //     <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            //         <i className="fa fa-ellipsis-v"></i>
            //     </Link>
            //     <div className="dropdown-menu dropdown-menu-right">
            //         <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
            //             <i className="ti ti-edit text-blue me-2"></i> Edit
            //         </div>

            //     </div>
            // </div>
        )
    },]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);

    const navigate = useNavigate()
    const BillToOpt = [
        { value: 'aizobel', label: 'Aizobel / INAZ' },
        { value: 'bagdogra', label: 'Bagdogra / INBD' },
        { value: 'akola', label: 'Akola / INAL' },
        { value: 'amritsar', label: 'Amritsar / INAR' }
    ]
    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Relation List<span className="count-title">23</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>

                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> */}

                                    <div className="">
                                        <label htmlFor="" className='mb-1 form-label'>
                                            Importer
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-0 me-2">
                                            <Select
                                                className='custom-selector'
                                                options={BillToOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="">
                                        <label htmlFor="" className='mb-1 form-label'>
                                            Consignor
                                        </label>
                                        <div className="icon-form mb-3 mb-sm-0 me-2">
                                            <Select

                                                className='custom-selector'
                                                options={BillToOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <Tooltip placement="top" title="Print Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="ti ti-printer text-white"></i>
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Export Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fas fa-file-export text-white"></i>

                                        </div>
                                    </Tooltip>
                                    <button type='submit' className="btn btn-primary me-2">
                                        Search
                                    </button>
                                    <a
                                        className='btn btn-light me-2'
                                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                    >
                                        Clear
                                    </a>
                                    <div
                                        className="btn btn-primary cursor-pointer me-2"
                                        onClick={handleAddShow}
                                    // onClick={() => { navigate("/flexichain/add-import-product") }}
                                    >
                                        <i className="ti ti-square-rounded-plus me-2" />
                                        Add Relation
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
        </>

    )
}

export default RelationList